export const creditShared = {
    layout: {
        productInfo: {
            showBalanceAndOutstandingAmount: true,
        },
    },

    menu: {
        supplementary: {
            enabled: true,
        },
    },
    reservations: {
        description: true,
        validFromTo: {
            enabled: true,
        },
        type: true,
        exchangeRate: true,
    },
    functions: {
        payUp: {
            noFlagNeeded: true,
        },
        tpLimits: {
            temporaryLimitDaysMode: true,
            editor: {
                limitTypes: ['POS', 'ATM', 'INTERNET', 'TOTAL'],
                showMaxLimitHelp: true,
            },
            validations: {
                INTERNET: {
                    biggerAsPOS: {
                        enabled: true,
                    },
                },
            },
        },
    },
    supplementary: {
        enabled: true,
        autoForward: true,
    },
    settings: {
        productWhitelist: ['MAIN', 'AUTHORIZED_STANDALONE'],
    },
    showAuthorizedAsSubCard: true,
};
